/*
 *
 *   reducer
 *
 */
import { produce } from "immer";

import {
  LOAD_ACTIVITIES_LIST_SUCCESS,
  LOAD_ACTIVITIES_LIST_ERROR,
  LOAD_ACTIVITIES_LIST_RECORDS_META_DATA_SUCCESS,
  LOAD_ACTIVITIES_LIST_RECORDS_META_DATA_ERROR,
  LOAD_STATE_ACTIVITIES_LIST_SUCCESS,
  LOAD_CITY_ACTIVITIES_LIST_SUCCESS,
  LOAD_AREA_ACTIVITIES_LIST_SUCCESS,
  LOAD_AREA_ACTIVITIES_LIST_ERROR,
  LOAD_SIMILAR_AREA_ACTIVITIES_LIST_SUCCESS,
  LOAD_SIMILAR_AREA_ACTIVITIES_LIST_ERROR,
  LOAD_ACTIVITIES_REVIEWS_LIST_SUCCESS,
  LOAD_SINGLE_ACTIVITIES_REVIEWS_LIST_SUCCESS,
  LOAD_STATE_ACTIVITIES_LIST_ERROR,
  LOAD_CITY_ACTIVITIES_LIST_ERROR,
  LOAD_ACTIVITIES_REVIEWS_LIST_ERROR,
  LOAD_SINGLE_ACTIVITIES_REVIEWS_LIST_ERROR,
  LOAD_CAB_DETAILS_SUCCESS,
  LOAD_CAB_DETAILS_ERROR,
} from "./constants";

const initialState = {
  activities_list: [],
  state_activities_list: [],
  cab_details_list: [],
  city_activities_list: [],
  area_activities_list: [],
  similar_packages_list: [],
  activities_reviews_list: [],
  single_activities_reviews: [],
  recordsMetaData: {},
  loading: false,
  error: false,
  success: false,
  lastUpdate: null,
};

const Reducer = (
  state = initialState,
  {
    type,
    activities_list,
    cab_details_list,
    state_activities_list,
    city_activities_list,
    area_activities_list,
    similar_packages_list,
    activities_reviews_list,
    single_activities_reviews,
    recordsMetaData = {},
    error,
    success,
  }
) => {
  return produce(state, (draft) => {
    switch (type) {
      case LOAD_ACTIVITIES_LIST_SUCCESS:
        draft.activities_list = activities_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_CAB_DETAILS_SUCCESS:
        draft.cab_details_list = cab_details_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_STATE_ACTIVITIES_LIST_SUCCESS:
        draft.state_activities_list = state_activities_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_CITY_ACTIVITIES_LIST_SUCCESS:
        draft.city_activities_list = city_activities_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_AREA_ACTIVITIES_LIST_SUCCESS:
        draft.area_activities_list = area_activities_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_SIMILAR_AREA_ACTIVITIES_LIST_SUCCESS:
        draft.similar_packages_list = similar_packages_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_ACTIVITIES_REVIEWS_LIST_SUCCESS:
        draft.activities_reviews_list = activities_reviews_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_SINGLE_ACTIVITIES_REVIEWS_LIST_SUCCESS:
        draft.single_activities_reviews = single_activities_reviews;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;

      case LOAD_ACTIVITIES_LIST_RECORDS_META_DATA_SUCCESS:
        draft.recordsMetaData = recordsMetaData;
        draft.error = false;
        draft.success = success;
        break;

      case LOAD_ACTIVITIES_LIST_ERROR:
      case LOAD_STATE_ACTIVITIES_LIST_ERROR:
      case LOAD_CITY_ACTIVITIES_LIST_ERROR:
      case LOAD_AREA_ACTIVITIES_LIST_ERROR:
      case LOAD_CAB_DETAILS_ERROR:
      case LOAD_SIMILAR_AREA_ACTIVITIES_LIST_ERROR:
      case LOAD_ACTIVITIES_REVIEWS_LIST_ERROR:
      case LOAD_SINGLE_ACTIVITIES_REVIEWS_LIST_ERROR:
        draft.loading = false;
        draft.error = error;
        draft.success = false;
        break;

      case LOAD_ACTIVITIES_LIST_RECORDS_META_DATA_ERROR:
        draft.error = error;
        draft.success = false;
        break;
      default:
        return state;
    }
  });
};

export default Reducer;
